import React from 'react';
import { DefaultSortOrder, DomainNode } from 'ui/sort-order/types';
import { SelectSingle } from 'ui/select-single/select-single';
import { moveSortOrderType, sortOrderType } from 'ui/sort-order/constants';
import { ComplexValue } from 'ui/common/types';
import { MeatballMenu, RadioSymbol } from 'ui';
import styles from './sort-by-item.scss';
import { OptionsType } from 'ui/common/select/types';

export interface SortByListItemProps {
  sortByItem: DefaultSortOrder;
  options: DomainNode[];
  translation: any;
  index: number;
  onMove: (type: number, value: number) => void;
  onSortOrderChange: (sortByItem: DefaultSortOrder) => void;
  onSortOrderRemove: (index: number) => void;
  loadOptions: (query?: string) => void;
  minNumber: number;
  maxNumber: number;
}

export const SortByListItem: React.FC<SortByListItemProps> = (props) => {
  const { sortByItem, options, minNumber, maxNumber, translation,
    loadOptions,
    onSortOrderChange,
    onSortOrderRemove,
    index,
    onMove
  } = props;

  const onSortOrderTypeChange = (e: React.SyntheticEvent<any>) => {
    const newValue = parseInt(e.currentTarget.value, 10);
    onSortOrderChange({ ...sortByItem, sortOrderType: newValue });
  };

  const handleRemove = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    onSortOrderRemove(index);
  };

  const onChange = (item: ComplexValue<number>) => {
    const newSortByItem = !item
      ? sortByItem
      : {
        ...sortByItem,
        domainNode: {
          value: item.value,
          description: item.description
        }
      };
    onSortOrderChange(newSortByItem);
  };

  const onMoveUp = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    onMove(sortByItem.domainNode.value, moveSortOrderType.UP);
  };

  const onMoveDown = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    onMove(sortByItem.domainNode.value, moveSortOrderType.DOWN);
  };


  const renderMenu = () => (
    <div className={styles.sortMeatballMenu}>
      <MeatballMenu closeAfterClick>
        <span>
          <li>
            <button type="button" className="dropdown-item" onClick={handleRemove}>
              {translation.sort_order_menu_option_remove}
            </button>
          </li>
          {sortByItem.orderBySequence !== minNumber ? (
            <li>
              <button type="button" className="dropdown-item" onClick={onMoveUp}>
                {translation.sort_order_menu_option_move_up}
              </button>
            </li>
          ) : null}
          {sortByItem.orderBySequence !== maxNumber ? (
            <li>
              <button type="button" className="dropdown-item" onClick={onMoveDown}>
                {translation.sort_order_menu_option_move_down}
              </button>
            </li>
          ) : null}
        </span>
      </MeatballMenu>
    </div>
  );

  return (
    <div className={styles.sortByTile}>
      <div className={styles.sortByTileTop}>
        <span className={`control-label ${styles.sortLabel}`}>
          {translation.sort_order_sort_by}
        </span>
        {maxNumber !== 1 ? renderMenu() : null}
      </div>
      <div className={styles.sortByWrapper}>
        <div className={styles.uiSortByTileTitle}>
          <SelectSingle
            componentId={'1'}
            className={'select-single'}
            label={{ visible: true }}
            valueItem={sortByItem.domainNode}
            options={options}
            optionsDisplaySetting={{ type: OptionsType.flat }}
            showIcons={true}
            onChange={onChange}
            onLoadOptions={(v: { query?: string }) => loadOptions(v?.query)}
            readOnly={false}
            disabled={true}
            placeholder={''}
            textOptionsDone={translation?.done}
            textPageOf={translation?.page_of}
            textOptionsNotFound={translation?.options_not_found}
          />
        </div>
        <fieldset className={styles.sortOrderList}>
          <legend className="visuallyhidden">
            {translation.sort_order_sort_by}
          </legend>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              id={`asc_${String(index)}`}
              name={String(index)}
              className="form-check-input visuallyhidden"
              value={sortOrderType.ASC}
              checked={sortByItem.sortOrderType === sortOrderType.ASC}
              onChange={onSortOrderTypeChange}
            />
            <label htmlFor={`asc_${String(index)}`} className="form-check-label align-items-start">
              <RadioSymbol />
              {translation.sort_order_asc}
              <div className={`${styles.ascLabel}`} />
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              id={`desc_${String(index)}`}
              name={String(index)}
              className="form-check-input visuallyhidden"
              value={sortOrderType.DESC}
              checked={sortByItem.sortOrderType === sortOrderType.DESC}
              onChange={onSortOrderTypeChange}
            />
            <label htmlFor={`desc_${String(index)}`} className="form-check-label align-items-start">
              <RadioSymbol />
              {translation.sort_order_desc}
              <div className={`${styles.descLabel}`} />
            </label>
          </div>
        </fieldset>
      </div>
    </div>
  );
};
